import * as React from "react";
//import * as ReactDOM from "react-dom";
import { ChaosToken } from "./Scenario";
import { MathUtil } from "./MathUtil";

interface IChaosBagState {
    current: ChaosToken;
}
export interface IChaosBagProps {
    chaosBag: ChaosToken[];
}
export class ChaosBagComponent extends React.Component<IChaosBagProps, IChaosBagState> {
    constructor(props: IChaosBagProps) {
        super(props);
        this.state = { current: this.drawARandomToken() }
    }
    private div:HTMLDivElement;
    drawARandomToken(): ChaosToken {
        const cb = this.props.chaosBag;
        const i = MathUtil.random(0, cb.length - 1);
        return cb[i];
    }
    sleep(ms = 0) {
        return new Promise(r => setTimeout(r, ms));
    }
    async draw() {
        let ct: ChaosToken;
        let times = 10;
        do {
            times--;
            ct = this.drawARandomToken();
            this.div.className = this.getCss(ct, times>0);
            await this.sleep(100);
        } while (times > 0)
        this.setState({ current: ct });
    }

    getCss(token: ChaosToken, rolling:boolean=false) :string {
        let css = `chaos-bag chaos-token chaos-${ChaosToken[token] as string}`;
        if (rolling)
            css += " rolling";
        return css.toLowerCase();

    }

    render() {
        let css = this.getCss(this.state.current);
        return (
            <div className={css} ref={(ref)=>this.div=ref} onClick={()=>this.draw()}>
            </div>
        );
    }
}
